export default function SupportPage() {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Support</h1>
        <p className="page-subtitle">We're here to help</p>
      </div>

      <div className="card" style={{ padding: '32px', maxWidth: '560px' }}>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: 'var(--text-secondary)', marginBottom: '16px' }}>
          If you're having trouble with your account, have a question about how StellarReply works, 
          or just want to share feedback, we'd love to hear from you.
        </p>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: 'var(--text-secondary)', marginBottom: '24px' }}>
          Drop us an email and we'll get back to you as soon as we can, usually within a few hours.
        </p>

        <a
          href="mailto:admin@opslife.co.uk"
          className="btn btn-primary"
          style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', textDecoration: 'none' }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: '18px', height: '18px' }}>
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          Email admin@opslife.co.uk
        </a>
      </div>
    </div>
  );
}
